export const scrollToFirstError = (): void => {
  const allErrors = document.querySelectorAll("[data-component=\"Error\"]");
  console.log("scrollToFirstError", allErrors);
  if (allErrors.length > 0) {
    (allErrors[0] as HTMLElement).scrollIntoView({ behavior: "smooth", block: "center" });
  }
};
